module.exports = __webpack_public_path__ + "img/logo-company.d35c9581.png";